// @flow

import { curry, indexBy, map, prop } from "ramda";
import { Maybe } from "ramda-fantasy";

import { createSelector } from "reselect";

import { type State, type TipoAtivo } from "../../state";
import { getTiposDeAtivosPermitidos } from "../selectors/usuarioSelectors";
import type { Id, FiltroTipoAtivo, GrupamentosMedida } from "../../model";

export const getGrupamentoMedidaSelecionado = (
  state: State
): GrupamentosMedida => state.grupamentoMedidaSelecionado;

export const isAlterouGrupamentoMedidaSelecionado = (state: State): boolean =>
  state.alterouGrupamentoMedidaSelecionado;

export const getFiltrosTipoAtivoSelecionados = (state: State): Array<Id> =>
  state.filtrosTipoAtivoSelecionados;

export const getFiltrosTipoAtivo = (state: State): Array<FiltroTipoAtivo> =>
  state.dominio.filtrosTipoAtivo;

export const getIdsFiltrosTipoAtivo: State => Array<Id> = createSelector(
  getFiltrosTipoAtivo,
  map(prop("id"))
);

export const isFiltroTipoAtivoSelecionado = (
  tipoAtivo: TipoAtivo,
  state: State
): boolean => {
  const idsSelecionados = getFiltrosTipoAtivoSelecionados(state);
  const idBuscado = Maybe(
    getFiltrosTipoAtivo(state).find(({ nome }) => nome === tipoAtivo)
  )
    .map(prop("id"))
    .getOrElse(null);

  return idsSelecionados.includes(idBuscado);
};

const getFiltrosIndexadosPorNome: State => {
  [string]: FiltroTipoAtivo,
} = createSelector(getFiltrosTipoAtivo, indexBy(prop("nome")));

export const getFiltroPorNome: (string, State) => ?FiltroTipoAtivo = curry(
  (nome, state) => getFiltrosIndexadosPorNome(state)[nome]
);

export const getFiltrosTipoAtivoPorIds = (
  state: State,
  ids: Array<Id>
): Array<FiltroTipoAtivo> =>
  state.dominio.filtrosTipoAtivo.filter(filtro => ids.includes(filtro.id));

export const getFiltrosTipoAtivoPermitidos: State => Array<FiltroTipoAtivo> = createSelector(
  getFiltrosTipoAtivo,
  getTiposDeAtivosPermitidos,
  (tipoAtivos, tipoAtivosPermitidos) =>
    tipoAtivos.filter(({ nome }) => tipoAtivosPermitidos.includes(nome))
);

export const getIdsFiltrosTipoAtivoPermitidos: State => Array<Id> = createSelector(
  getFiltrosTipoAtivoPermitidos,
  map(prop("id"))
);
